import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeneratedRule } from '../../planogram/planogram-edit/components/layout-rules/models/generatedRule';
import { IPlanogramData } from '../../planogram/models/planogramData';

@Injectable()
export class RulesService {

	constructor(private httpClient: HttpClient) {}

	generateRule(text: string, store: number, shelves: number, lang: string): Observable<GeneratedRule> {
		return this.httpClient.post<GeneratedRule>(
			`/api/v1/landing/rules/generate/`,
			{ text: text, shop: store, total_shelves: shelves },
			{ params: new HttpParams({ fromObject: { lang: lang } }) }
		);
	}

	getPlanogram(id: number, params: any = {}): Observable<IPlanogramData> {
		return this.httpClient.get<IPlanogramData>(
			`/api/v1/landing/rules/planograms/${id}/`,
			{
				params: new HttpParams({
					fromObject: params
				})
			}
		);
	}

	getPlanograms(params: any = {}): Observable<Array<{ id: number; name: string; }>> {
		return this.httpClient.get<Array<{ id: number; name: string; }>>(
			`/api/v1/landing/rules/planograms/`,
			{
				params: new HttpParams({
					fromObject: params
				})
			}
		);
	}
}